import { render, staticRenderFns } from "./choosestaffmulti.vue?vue&type=template&id=b4594586&scoped=true"
import script from "./choosestaffmulti.vue?vue&type=script&lang=js"
export * from "./choosestaffmulti.vue?vue&type=script&lang=js"
import style0 from "./choosestaffmulti.vue?vue&type=style&index=0&id=b4594586&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4594586",
  null
  
)

export default component.exports